interface MutexInterface {
  acquire: () => Promise<void>;
  release: () => void;
}

/**
 * 可实现对异步方法添加锁
 * 确保获取锁之后的逻辑 只能在释放锁之后执行
 */
export class Mutex implements MutexInterface {
  private queue: Array<() => void> = [];

  private maxConcurrency = 1;

  /**
   * 获取锁
   */
  async acquire() {
    if (this.maxConcurrency <= 0) {
      await new Promise<void>((resolve) => {
        this.queue.push(resolve);
      });
    }
    this.maxConcurrency -= 1;
  }

  /**
   * 释放锁
   */
  release() {
    this.maxConcurrency += 1;
    this.queue.shift()?.();
  }
}
